export default {
  submitText: '销账',
  emptyBtn: false,
  labelWidth: 120,
  column: [
    {
      label: '费用种类',
      prop: 'feeSort',
      type: 'select',
      disabled: true,
      dataType: 'number',
      dicUrl: 'api/blade-system/dict/dictionary?code=fee_sort',
      props: { label: 'dictValue', value: 'dictKey' },
      mock: {
        type: 'dic',
      },
    },
    {
      label: '扣款银行',
      prop: 'cutBank',
      type: 'select',
      disabled: true,
      dataType: 'number',
      dicUrl: 'api/blade-system/dict/dictionary?code=bill_cutBank',
      props: { label: 'dictValue', value: 'dictKey' },
      rules: [
        {
          required: true,
          trigger: 'blur',
        },
      ],
    },
    {
      label: '扣款笔数',
      prop: 'cutNum',
      disabled: true,
    },
    {
      label: '扣款总额(元)',
      prop: 'cutAmount',
      disabled: true,
    },
    {
      label: '更新备注',
      prop: 'backRemark',
      type: 'textarea',
      minRows: 5,
      maxlength: 100,
      span: 24,
      showWordLimit: true,
    },
  ],
};
